import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { userQueryPayload } from "../../app/main/main.types";
import { dataAuthCall, emailAuthCheckCall, fireBaseAuthCall, phoneNumberSubmit } from "./auth.thunk";
import { AuthError, AuthState } from "./auth.types";

const initialState: AuthState = {
  fireBaseAuth: false,
  dataAuth: false,
  isFbAuthLoading: false,
  isMobTokenLambdaLoading: false,
  isAuthLoading: true,
  authError: null,
  userHasuraID: null,
  isExistingUser: null,
  otpLogin: {
    phone: null,
    otpError: false,
  },
  loaders: {
    isPhoneNumberSubmitLoading: false,
    isEmailNameSubmitLoading: false,
  },
  redirectParam: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setFireBaseAuth: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.fireBaseAuth = action.payload;
    },
    setDataAuth: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.dataAuth = action.payload;
    },
    logoutUser: (state) => {
      state.dataAuth = false;
      state.fireBaseAuth = false;
      state.dataAuth = false;
      state.userHasuraID = null;
      state.isExistingUser = null;
      state.otpLogin.phone = null;
    },
    setAppInitAuth: (state, action: PayloadAction<{ fireBaseAuth: boolean, dataAuth: boolean }>) => {
      state.fireBaseAuth = action.payload.fireBaseAuth;
      state.dataAuth = action.payload.dataAuth;
    },
    setUserHasuraID: (state, action: PayloadAction<userQueryPayload>) => {
      state.userHasuraID = action.payload.userHasuraId;
      state.isAuthLoading = false;
    },
    authFulfilled: (state, action) => {
      state.isAuthLoading = false;
      state.userHasuraID = action.payload.userHasuraID;
      state.isExistingUser = action.payload.isExistingUser;
      state.dataAuth = true;
    },
    authRejected: (state) => {
      state.authError = true;
      state.isAuthLoading = false;
    },
    authPending: (state, action) => {
      state.isAuthLoading = true;
    },
    setIsAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.isAuthLoading = action.payload;
    },
    setOtpLoginPhone: (state, action: PayloadAction<string>) => {
      state.otpLogin.phone = action.payload;
    },
    setAuthError: (state, action: PayloadAction<AuthError>) => {
      state.authError = action.payload;
    },
    setIsExistingUser: (state, action: PayloadAction<boolean | null>) => {
      state.isExistingUser = action.payload;
    },
    setRedirectParam: (state, action: PayloadAction<string | null>) => {
      state.redirectParam = action.payload;
    },
    setPhoneNumber: (state, action: PayloadAction<string | null>) => {
      state.otpLogin.phone = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fireBaseAuthCall.pending, (state) => {
      state.isAuthLoading = true;

    }).addCase(fireBaseAuthCall.fulfilled, (state, action) => {
      state.fireBaseAuth = true;
      state.authError = null;

    }).addCase(fireBaseAuthCall.rejected, (state, action) => {
      state.isAuthLoading = false;
      state.authError = action.error;

    }).addCase(dataAuthCall.fulfilled, (state, action) => {
      if (action.payload) {
        state.dataAuth = true;
      }
      state.isAuthLoading = false;

    }).addCase(emailAuthCheckCall.fulfilled, (state, action) => {
      state.loaders.isEmailNameSubmitLoading = false;
      state.userHasuraID = action.payload.userHasuraID;
      state.dataAuth = true;
      state.isExistingUser = action.payload.isExistingUser;

    }).addCase(emailAuthCheckCall.pending, (state, action) => {
      state.loaders.isEmailNameSubmitLoading = true;

    }).addCase(emailAuthCheckCall.rejected, (state, action) => {
      state.loaders.isEmailNameSubmitLoading = false;

    }).addCase(phoneNumberSubmit.pending, (state) => {
      state.loaders.isPhoneNumberSubmitLoading = true;
      state.authError = null;

    }).addCase(phoneNumberSubmit.fulfilled, (state, action) => {
      state.loaders.isPhoneNumberSubmitLoading = false;
      state.otpLogin.phone = action.payload.phoneNumber;
      state.redirectParam = action.payload.redirecturl;

    }).addCase(phoneNumberSubmit.rejected, (state) => {
      state.loaders.isPhoneNumberSubmitLoading = false;

    })

  }
});

export const {
  setFireBaseAuth,
  setDataAuth,
  logoutUser,
  setAppInitAuth,
  setUserHasuraID,
  authFulfilled,
  authRejected,
  authPending,
  setIsAuthLoading,
  setOtpLoginPhone,
  setAuthError,
  setIsExistingUser,
  setRedirectParam,
  setPhoneNumber
} = authSlice.actions;

export default authSlice.reducer;